import React, { lazy, Suspense } from 'react';
import { Spin } from 'antd';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import Dashboard from './dashboard';
import withAdminLayout from '../../layout/withAdminLayout';

// Admin views
import Sucursales from './sucursales';
import Empleados from './empleados';
import Servicios from './servicios';
import Productos from './productos';

// Clinica
import Clinica from './clinica';
import Gastos from './gastos';

// Configuracion views
import CategoriaServicios from './categoriaServicios';
import TipoOrigenPaciente from './tipoOrigenPaciente';
import ClaveDescuento from './claveDescuento';
import EsquemasContractuales from './esquemasContractuales';

//Ventas
import Empresas from './empresas';

//Finanzas
import PagosRegistrados from './pagosRegistrados';

const Calendars = lazy(() => import('../../container/Calendar'));
const Myprofile = lazy(() => import('../../container/profile/myProfile/Index'));
const Calendar = lazy(() => import('../../container/calendar/Calendar'));

const Admin = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Suspense
        fallback={
          <div className="spin">
            <Spin />
          </div>
        }
      >
        <Route path={path} component={Dashboard} />
        <Route path={`${path}`} component={Sucursales} />
        <Route path={`${path}`} component={Empleados} />
        <Route path={`${path}`} component={Clinica} />
        <Route path={`${path}`} component={Gastos} />
        <Route path={`${path}`} component={Servicios} />                    
        <Route path={`${path}`} component={Productos} />  
        <Route path={`${path}`} component={CategoriaServicios} />                    
        <Route path={`${path}`} component={TipoOrigenPaciente} />                    
        <Route path={`${path}`} component={ClaveDescuento} />                    
        <Route path={`${path}`} component={EsquemasContractuales} />                    
        <Route path={`${path}`} component={Empresas} />                    
        <Route path={`${path}`} component={PagosRegistrados} />                    
        <Route path={`${path}/calendar`} component={Calendars} />                             
        <Route path={`${path}/profile/myProfile`} component={Myprofile} />                
        <Route path={`${path}/app/calendar`} component={Calendar} />
      </Suspense>
    </Switch>
  );
};

export default withAdminLayout(Admin);
